import { createContext } from 'react';

export const KodieContext = createContext({
	context: null,
});
